<a
  (click)="authenticatorService.toSignIn()"
  [routerLink]="'/auth/login'"
  [routerLinkActive]="'active'"
  class="login-button-link mobile-link"
  mat-icon-button
  [attr.aria-label]="'HEADER.BTN.LOGIN' | translate"
  ><mat-icon>login</mat-icon>
</a>
<a
  (click)="authenticatorService.toSignIn()"
  [routerLink]="'/auth/login'"
  [routerLinkActive]="'active'"
  class="login-link"
  mat-flat-button
  color="primary"
  >{{ "HEADER.BTN.LOGIN" | translate }}
</a>
<a
  [routerLink]="'/auth/merchant-registration'"
  [routerLinkActive]="'active'"
  mat-flat-button
  class="registration-link"
  >{{ "HEADER.BTN.REGISTER" | translate }}
</a>
